import { Box, Button, Divider, Grid, ThemeProvider, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { AutocompleteInput, Edit, required, SaveButton, SimpleForm, TextInput, Toolbar, useEditController } from "react-admin";
import { allCities, allStates, getCountry } from "../../services/State";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import { getAllSubMerchant } from "../../services/SubMerchant";
import { getMerchantNames } from "../../services/Merchant";
import CustomDeleteButton from "./components/CustomDeleteButton";
import Color from "../layout/color/Color";
import FontSize from "../layout/FontSize";
import theme from "../layout/theme/Theme";


const verifyButton = {
    bgcolor: Color.Main,
    borderRadius: '30px',
    border: '1px solid Color.Main',
    fontWeight: '500',
    textAlign: 'center',
    padding: '8px 15px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Button, color: Color.Normal }
  };
  
  const backButton = {
    bgcolor: Color.Button,
    borderRadius: '30px',
    border: "1px solid #055C2D",
    color: Color.Main,
    fontWeight: '500',
    textAlign: 'center',
    padding: '8px 15px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Main, color: Color.Button }
  };
const SubMerchantCreateToolbar = (props) => {
    const navigate = useNavigate();
    const handleBack = (e) => {
        e.preventDefault();
        navigate('/SubMerchant')
    }
    return (
        <Toolbar sx={{ justifyContent: 'space-between' }} {...props}>
            <Button
                startIcon={<KeyboardBackspaceIcon  sx={{color: Color.Main}}/>}
                onClick={handleBack}
                sx={backButton}
            >
                Back
            </Button>
            <SaveButton  sx={verifyButton} />
        </Toolbar>
    )
}

export const SubMerchantEdit = (props) => {
    const editContext = useEditController();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const [states, setStates] = useState([]);
    const [state, setState] = useState();
    const [submerchants, setSubmerchants] = useState([]);
    const [merchantName, setMerchantName] = useState('');
    const [cities, setCities] = useState([]);
    const [country, setCountry] = useState(null);

    useEffect(() => {
        const fetchAPI = async () => {
            try {
                const response = await getCountry(parseInt(localStorage.getItem('merchantID')));
                if (response !== null && response !== undefined)
                    setCountry(response.country)
            } catch (err) {
                console.log(err);
            }
        }

        fetchAPI();

        const getSubMerchantList = async () => {
            const response = await getAllSubMerchant();
            if (response !== null) setSubmerchants(response.allSubMerchants);
        }

        getSubMerchantList();

        const getMerchantName = async () => {
            const response = await getMerchantNames();
            if (response !== null) setMerchantName(response[0].name);
        }

        getMerchantName();
    }, [])

    useEffect(() => {
        const fetchAPI = async () => {
            try {
                if (country !== null) {
                    const response = await allStates(country);
                    if (response !== null && response !== undefined) setStates(response);
                }
            } catch (err) {
                console.log(err);
            }
        }

        fetchAPI();
    }, [country])

    useEffect(() => {
        if (!editContext.isLoading) {
            setState(editContext.record.state);
        }
    }, [editContext])
    useEffect(() => {
        const fetchAPI = async () => {
            if (states.length > 0) {
                const response = await allCities(state);
                setCities(response);
            }
        }

        fetchAPI();
    }, [state, states])

    return (
        <ThemeProvider theme={theme}>
          <Box>
            <Edit {...props}>
                <Box sx={{ px: `${matchDownSM ? 2 : 5}`, justifyContent: 'center' }}>
                    <SimpleForm toolbar={<SubMerchantCreateToolbar />}>
                        <Grid 
                        sx={{ 
                            textAlign: 'left',
                             display: 'flex',
                              justifyContent: 'space-between',
                               width: '100%',
                               mb:2
                                }}>
                            <Button endIcon={<OtherHousesIcon sx={{ color: Color.Main}} />} sx={{ textAlign: 'left', ml: 1, cursor: 'default' }} size="medium">
                                <Typography variant="h4">
                                    Edit SubMerchant
                                </Typography>
                            </Button>
                            <CustomDeleteButton />
                        </Grid>
                        <Divider sx={{ width: '100%', mb: 2 }} />
                        <Grid item container spacing={2}>
                            <Grid item xs={12} sx={{ display: 'flex', textAlign: 'center', justifyContent: 'center', alignItems: 'center', pt: 1, pb: 2 }}>
                                <Typography variant="h4" sx={{ mr: 1 }}>Merchant:</Typography>
                                <Typography variant="h4">{merchantName !== '' && merchantName}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item container spacing={2} sx={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={5} >
                                <TextInput source="name" label="SubMerchant name" variant="outlined" required />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', textAlign: 'center', pt: 4 }}>
                            <Grid container spacing={2} item
                                sx={{ px: `${matchDownSM ? '2rem' : '15rem'}` }}
                            >
                                <Grid item xs={12} md={6}  >
                                    <AutocompleteInput
                                        fullWidth
                                        variant="outlined"
                                        label="SubMerchant"
                                        source="submerchantID"
                                        optionText="name"
                                        choices={submerchants}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}  >
                                    <TextInput required variant="outlined" source="zip" label='Zip' fullWidth />
                                </Grid>

                                <Grid item xs={12} md={6}  >
                                    <AutocompleteInput
                                        fullWidth
                                        validate={[required()]}
                                        variant="outlined"
                                        source="state"
                                        label="State"
                                        choices={states}
                                        value={state}
                                        onChange={(newValue) => {
                                            setState(newValue);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}  >
                                    <AutocompleteInput
                                        fullWidth
                                        validate={[required()]}
                                        variant="outlined"
                                        source="city"
                                        label="City"
                                        choices={cities}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}  >
                                    <TextInput variant="outlined" source="address" required label="Address" fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}  >
                                    <TextInput variant="outlined" source="phone" required label="Phone Number" fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}  >
                                    <TextInput variant="outlined" source="email" required label="Emaill" fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}  >
                                    <TextInput variant="outlined" source="bank_account" required label="Bank Account" fullWidth />
                                </Grid>
                            </Grid>
                        </Grid>
                    </SimpleForm>
                </Box>
            </Edit >
        </Box>
            
        </ThemeProvider>
      
    )
}